import { render, staticRenderFns } from "./DadosPesagem.vue?vue&type=template&id=535f7396"
import script from "./DadosPesagem.vue?vue&type=script&lang=js"
export * from "./DadosPesagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports